import { render, staticRenderFns } from "./SubscriptionsSettings.vue?vue&type=template&id=9fcc46bc&scoped=true&"
import script from "./SubscriptionsSettings.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsSettings.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsSettings.vue?vue&type=style&index=0&id=9fcc46bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcc46bc",
  null
  
)

export default component.exports